/* eslint-disable */ import { createPresetsFactory } from '@salsita-ai/platform-project-sdk/domain';
export const createPresets = createPresetsFactory();
export const generatedPresets = createPresets([
    {
        name: 'Basic Swim Shorts',
        description: 'Simple starting configuration',
        rootEntityType: 'SwimShorts',
        tags: [
            'empty-swim-shorts'
        ],
        initialDomainEntities: [
            {
                id: 'SwimShorts-1',
                type: 'SwimShorts',
                collection: 'solid',
                design: 'white',
                liner: 'mesh',
                fabric: '90/10 stretch',
                size: 'l',
                inseam: 0
            },
            {
                id: 'LeftLeg-1',
                type: 'LeftLeg',
                collection: 'solid',
                design: 'white'
            },
            {
                id: 'RightLeg-1',
                type: 'RightLeg',
                collection: 'solid',
                design: 'white'
            },
            {
                id: 'LeftThighBand-1',
                type: 'LeftThighBand',
                collection: 'solid',
                design: 'White'
            },
            {
                id: 'RightThighBand-1',
                type: 'RightThighBand',
                collection: 'solid',
                design: 'white'
            },
            {
                id: 'Waistband-1',
                type: 'Waistband',
                collection: 'solid',
                design: 'white'
            },
            {
                id: 'Drawstring-1',
                type: 'Drawstring',
                color: 'black'
            }
        ]
    },
    {
        name: 'Basic Board Shorts',
        description: 'Simple starting configuration',
        rootEntityType: 'BoardShorts',
        tags: [
            'empty-board-shorts'
        ],
        initialDomainEntities: [
            {
                id: 'BoardShorts-1',
                type: 'BoardShorts',
                collection: 'solid',
                design: 'white',
                liner: 'none',
                fabric: '90/10 stretch',
                size: 'l',
                inseam: 0
            },
            {
                id: 'LeftLeg-1',
                type: 'LeftLeg',
                collection: 'solid',
                design: 'white'
            },
            {
                id: 'RightLeg-1',
                type: 'RightLeg',
                collection: 'solid',
                design: 'white'
            },
            {
                id: 'LeftThighBand-1',
                type: 'LeftThighBand',
                collection: 'solid',
                design: 'white'
            },
            {
                id: 'RightThighBand-1',
                type: 'RightThighBand',
                collection: 'solid',
                design: 'white'
            },
            {
                id: 'Waistband-1',
                type: 'Waistband',
                collection: 'solid',
                design: 'white'
            },
            {
                id: 'Drawstring-1',
                type: 'Drawstring',
                color: 'black'
            }
        ]
    }
]);

//# sourceMappingURL=presets.js.map